import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useSelector } from 'react-redux';
import { selectServerIP } from '../../api/serverIpSlice';

const ServerIpDisplay = () => {
  const ips = useSelector(selectServerIP);

  if (!ips || ips.length === 0) return null;

  const firstIp = ips[0];
  const ipText = (
    <span style={{cursor: 'default'}}>{firstIp}</span>
  );

  if (ips.length > 1) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="ip-tooltip" className="custom-tooltip">
            {ips.join(', ')}
          </Tooltip>
        }
      >
        <span style={{cursor:'pointer'}}>{firstIp}</span>
      </OverlayTrigger>
    );
  }
  return ipText;
};

export default ServerIpDisplay;
